import Service from "./apiService";

class UsersService extends Service {
  getData() {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `users`,
      method: "GET",
    });
  }

  get(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `users/${id}`,
      method: "GET",
    });
  }  

  add(form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `users`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  update(id, form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `users/${id}`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  delete(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `users/${id}`,
      method: "DELETE",
    });
  }
}

export var usersService = new UsersService();
